import { useState } from "react";
import { useDispatch } from "react-redux";

import { setSection } from "../../../assignmentSlice";

import { typeInfo } from "../../../../../constants/typeInfo";

import CommonPage from "../../common/CommonPage";

const MultipleChoicePage = ({
  section,
  pageList,
  currentPage,
  currentIndex,
  setPageList,
  handlePreviousPage,
  handleNextPage,
}) => {
  const dispatch = useDispatch();

  const [overlayVisible, setOverlayVisible] = useState(false);

  const selectOption = ({ optionIndex }) => {
    const realIndex = optionIndex + 1;
    const newPageList = pageList.map((page, index) => {
      if (index === currentIndex) {
        let inputList = page.input;
        if (inputList.includes(realIndex)) {
          inputList = inputList.filter((input) => input !== realIndex);
        } else {
          inputList = [...inputList, realIndex];
        }
        return {
          ...page,
          input: inputList,
        };
      }
      return page;
    });
    setPageList(newPageList);
  };

  const handleSubmit = () => {
    if (currentPage.isSubmitted) return;
    const isCorrect =
      currentPage.answer.length === currentPage.input.length &&
      currentPage.input.every((input) => currentPage.answer.includes(input));
    const newPageList = pageList.map((page, index) => {
      if (index === currentIndex) {
        return {
          ...page,
          isCorrect,
          isSubmitted: true,
        };
      }
      return page;
    });
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));

    setOverlayVisible(true);
    setTimeout(() => {
      setOverlayVisible(false);
    }, 600);
  };

  return (
    <CommonPage
      currentIndex={currentIndex}
      currentPage={currentPage}
      handlePreviousPage={handlePreviousPage}
      handleNextPage={handleNextPage}
      totalNo={pageList.length}
      paragraph={currentPage.text}
      overlayVisible={overlayVisible}
      isCorrect={currentPage.isCorrect}
      handleSubmit={handleSubmit}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "30px",
        }}
      >
        <div
          style={{
            fontSize: "24px",
          }}
        >
          {currentIndex + 1}.{" "}
          {currentPage.question.replace(
            "의 개수를 적으시오.",
            "을 모두 고르시오."
          )}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "14px",
            maxHeight: "50vh",
            overflowY: "auto",
          }}
        >
          {currentPage.choices.map((option, optionIndex) => {
            return (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "75vw",
                  padding: "16px 20px",
                  border: "1px solid #EBEBEB",
                  borderRadius: "5px",
                  fontWeight:
                    currentPage.input.includes(optionIndex + 1) ||
                    (currentPage.isSubmitted &&
                      currentPage.answer.includes(optionIndex + 1))
                      ? "bold"
                      : "normal",
                  cursor: !currentPage.isSubmitted && "pointer",
                  backgroundColor: currentPage.isSubmitted
                    ? currentPage.answer.includes(optionIndex + 1)
                      ? typeInfo["paragraph"].backgroundColor
                      : currentPage.input.includes(optionIndex + 1) &&
                        "rgba(240, 52, 52, 0.5)"
                    : currentPage.input.includes(optionIndex + 1) &&
                      typeInfo["paragraph"].backgroundColor,
                  color: currentPage.isSubmitted
                    ? currentPage.answer.includes(optionIndex + 1)
                      ? currentPage.input.includes(optionIndex + 1)
                        ? typeInfo["paragraph"].color
                        : "#FF4444"
                      : currentPage.input.includes(optionIndex + 1) && "white"
                    : currentPage.input.includes(optionIndex + 1) &&
                      typeInfo["paragraph"].color,
                  fontSize: "20px",
                }}
                onClick={() => {
                  if (currentPage.isSubmitted) return;
                  selectOption({ optionIndex });
                }}
              >
                {option}
              </div>
            );
          })}
        </div>
      </div>
    </CommonPage>
  );
};

export default MultipleChoicePage;
